import request from '@/api/request';

export function index(url, data) {
    return request({
        url: "/" + url,
        method: 'get',
        params: data
    });
}

export function create(url, data) {
    return request({
        url: "/" + url,
        method: 'post',
        data
    });
}

export function update(url, id, data) {
    return request({
        url: "/" + url + "/" + id,
        method: 'put',
        data
    });
}

export function show(url, id, data) {
    return request({
        url: "/" + url + "/" + id,
        method: 'get',
        params: data
    });
}

export function deleteQuery(url, id) {
    return request({
        url: "/" + url + "/" + id,
        method: 'delete'
    });
}

export function captcha(data) {
    return request({
        url: "captcha",
        method: 'get',
        params: data
    });
}

// export async function upload(e) {
//     const arr = [];
//     for (let i of e.target.files) {
//         const data = await request({
//             url: '/mapsOss',
//             method: 'get'
//         });
//         if (data && data.code === 0) {
//             let uploadData = await uploadSuccess(data.data.uploadUrl, data.data.uploadToken, i);
//             // console.log('uploadData', i);
//             arr.push({ name: i.name, url: data.data.baseUrl + uploadData.data.hash })
//         } else {
//             return null;
//         }
//     }
//     return arr
// }

// import axios from 'axios';

// export async function uploadSuccess(url, token, e) {
//     let data = new FormData();
//     data.append('token', token);
//     data.append('file', e);
//     return await axios.post(url, data, {
//         'Content-Type': 'multipart/form-data'
//     })
// }

// 上传图片
export  function uploadImg() {
    return request({
        url: '/mapsOss',
        method: 'get'
    });
}
export function login() {
    return request({
        url: '/login',
        method: 'post',
        data
    });
}

export async function getCityData(data = {}) {
    const res = await request({
        url: '/allCityMaps',
        method: 'get'
    });
    const cityData = [
        {
          "id": "100000",
          "name": "中国",
          "parentId": "0"
        },
    ];
    for(let i = 0; i< res.data.province.length; i++) {
        cityData.push({
            id: 'province' + res.data.province[i].id,
            name: res.data.province[i].name,
            parentId: "100000"
        })
        if(!data.notAll) {
          cityData.push({
            id: 'cityAll' + res.data.province[i].id,
            name: '全部',
            parentId: 'province' + res.data.province[i].id
          })
        }
    }
    for(let i = 0; i< res.data.city.length; i++) {
        cityData.push({
            id: 'city' + res.data.city[i].id,
            name: res.data.city[i].name,
            parentId: 'province' + res.data.city[i].pid
        })
        if(!data.notAll) {
          cityData.push({
            id: 'areaAll' + res.data.city[i].id,
            name: '全部',
            parentId: 'city' + res.data.city[i].id
          })
        }
    }
    for(let i = 0; i< res.data.area.length; i++) {
        cityData.push({
          id: res.data.area[i].id,
          name: res.data.area[i].name,
          parentId: 'city' + res.data.area[i].cid
        })
    }
    return cityData;
}